import { FC } from 'react'
import Image from 'next/image'
import styled, { css } from 'styled-components'
import Portal from '@app.components/Portal'
import ExternalLoading from './ExternalLoading'

interface IFProps {}

const ResultLoadingPopup: FC<IFProps> = () => {
  return (
    <Portal id="result-loading-popup">
      <StyledWrapper>
        <div className="popup-content">
          <strong>결과를 불러오고 있습니다.</strong>
          <div className="loading-image-wrapper">
            <figure>
              <figcaption>결과 요청 로딩 팝업</figcaption>
              <Image
                src="/static/images/career/external_data_loading.png"
                width={140}
                height={140}
                alt="결과 요청 로딩"
              />
            </figure>
          </div>
          <ExternalLoading />
        </div>
      </StyledWrapper>
    </Portal>
  )
}

export default ResultLoadingPopup

const StyledWrapper = styled.article`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 500;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.7);

    & > .popup-content {
      width: 280px;
      height: 300px;
      background-color: ${theme.background.bg_8};
      border-radius: 20px;
      padding: 40px;
      position: absolute;
      z-index: 600;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      & > strong {
        width: 100%;
        height: 26px;
        font-size: 18px;
        font-weight: bold;
        line-height: 26px;
        letter-spacing: -0.72px;
        text-align: center;
        color: ${theme.color.text_1};
        margin-bottom: 8px;
        display: block;
      }

      & > p.loading-description {
        // 전역으로 잡힌 스타일보다 우선순위를 높게 잡아야 합니다
        height: 40px;
        font-size: 14px;
        font-weight: normal;
        line-height: 20px;
        letter-spacing: -0.56px;
        text-align: center;
        color: ${theme.color.text_1};
        margin-bottom: 20px;
      }

      & > .loading-image-wrapper {
        width: 140px;
        height: 140px;
        margin: 0 auto 20px;

        & > figure {
          width: 100%;
          height: 100%;
          margin: 0;
          padding: 0;

          & > figcaption {
            width: 0;
            height: 0;
            font-size: 0;
          }
        }
      }
    }
  `}
`
